const TOTAL_AMT_INFO = 'index/TOTAL_AMT_INFO' as const;
const SET_TOTAL_AMT_INFO = 'index/SET_TOTAL_AMT_INFO' as const;

export const getTotalAmtInfo = () => ({
  type: TOTAL_AMT_INFO,
});
export const setTotalAmtInfo = (state: TotalAmtState) => ({
  type: SET_TOTAL_AMT_INFO,
  payload: state,
});

type TotalAmtAction = ReturnType<typeof getTotalAmtInfo> | ReturnType<typeof setTotalAmtInfo>;

export type TotalAmtState = {
  amount: string;
  chainId: number;
};
const initialState: TotalAmtState = {
  amount: '0',
  chainId: 0,
};

function totalAmt(state: TotalAmtState = initialState, action: TotalAmtAction): any {
  switch (action.type) {
    case TOTAL_AMT_INFO:
      return { ...state };
    case SET_TOTAL_AMT_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default totalAmt;
